import React from "react";
import mapboxgl from "mapbox-gl";
import { getLineGeojsonFromPoints, getPointsGeojsonFromPoints } from "../utils";
import { MAP_ACTIONS } from "../utils/constants";

class Map extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      lat: 12.977529081680132,
      lng: 77.57247169985196,
      zoom: 11,
      supported: mapboxgl.supported(),
    };

    this.importInput = React.createRef();
    this.mapContainer = React.createRef();
    this.map = null;
  }

  initMap = () => {
    if(!this.mapContainer.current) {
      return;
    }
    const { lng, lat, zoom } = this.state;
    const map = new mapboxgl.Map({
      container: this.mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
      minZoom: 10,
      maxZoom: 18,
    });
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();

    map.on("move", () => {
      this.setState({
        lng: map.getCenter().lng.toFixed(4),
        lat: map.getCenter().lat.toFixed(4),
        zoom: map.getZoom().toFixed(2),
      });
    });
    this.map = map;
  };

  componentDidMount() {
    if (this.state.supported) {
      this.initMap();
      this.map?.on("load", () => {
        this.map.addSource('line', {
          type: 'geojson',
          data: getLineGeojsonFromPoints(this.props.points),
        });
        this.map.addSource('points', {
          type: 'geojson',
          data: getPointsGeojsonFromPoints(this.props.points),
        });
  
        this.map.addLayer({
          id: 'line',
          type: 'line',
          source: 'line',
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: {
            'line-color': '#4a80f5',
            'line-width': 4
          }
        });

        this.map.addLayer({
          id: 'points',
          type: 'circle',
          source: 'points',
          paint: {
            'circle-radius': 8,
            'circle-color': '#4a80f5'
          }
        });

        this.map.addLayer({ 
            id: 'selected-point',
            type: 'circle', 
            source: 'points',
            paint: {
              'circle-radius': 8,
              'circle-color': '#ffffff',
              "circle-stroke-width": 2,
              "circle-stroke-color": "#4a80f5",
            },
            filter: ['==', 'index', this.props.selectedPointIndex]
          });

        const canvas = this.map.getCanvasContainer();
        canvas.style.cursor = 'crosshair';
        this.map.on('mouseenter', 'points', () => {
            canvas.style.cursor = 'all-scroll';
        });
  
        this.map.on('mouseleave', 'points', () => {
          canvas.style.cursor = 'crosshair';
        });
  
        this.map.on('mousedown', 'points', (e) => {
          e.preventDefault();
          this.map.on('mousemove', this.mouseMoveOnPoint);
          this.map.once('mouseup', this.mouseUpOnPoint);
          this.props.selectPoint(e.features[0].properties.index);
        });


        this.map.on('click', 'points', (e) => {
            e.preventDefault();
            e.clickOnPoints = true;
        });

        this.map.on('click', (e) => {
            if(e.clickOnPoints) {
                return;
            }
            this.props.addPoint([e.lngLat.lng, e.lngLat.lat]);
        });
  
        // this.map.on('touchstart', 'points', (e) => {
        //   if (e.points.length !== 1) return;
        //   e.preventDefault();
        //   this.map.on('touchmove', this.mouseMoveOnPoint);
        //   this.map.once('touchend', this.mouseUpOnPoint);
        // });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.points !== this.props.points) {
      this.map.getSource("points").setData(getPointsGeojsonFromPoints(this.props.points));
      this.map.getSource("line").setData(getLineGeojsonFromPoints(this.props.points));
    }
    if (prevProps.selectedPointIndex !== this.props.selectedPointIndex) {
      this.map.setFilter('selected-point', ['==', 'index', this.props.selectedPointIndex]);
    //   this.map.getSource("points").setData(this.props.points);

    }
  }

  mouseMoveOnPoint = (e) => {
    this.props.movePoint(
        [e.lngLat.lng, e.lngLat.lat]
    );
  }

  mouseUpOnPoint = (e) => {
    this.map.off('mousemove', this.mouseMoveOnPoint);
  }

  componentWillUnmount() {
    this.map?.remove();
  }

  render() {
    return (
      <div id="map" ref={this.mapContainer} className="map-container">
        {/* <MapActions mapAction={mapAction} onMapActionChange={this.onMapActionChange} /> */}
      </div>
    );
  }
}

export default Map;